import styled from '@emotion/styled';
import { Row, Col } from 'react-bootstrap';

import CONST from '../constants';
import { Container, Body, Title } from './Common';
import imgBusinessEnvironment from '../resources/analysis-1.jpg';
import imgWideAreaTransportation from '../resources/analysis-2.jpg';
import imgTrafficOverview from '../resources/analysis-3.jpg';
import imgDevelopmentOverview from '../resources/analysis-4.jpg';

const BREAKPOINT_LIMIT = CONST.SCREEN.BREAKPOINT.XL;

const Section = {
    SubTitle: styled.p`
        display: block;
        position: relative;
        margin: 0;
        color: ${CONST.COLOR.THEME};
        font-size: 4vw;
        text-align: center;
        line-height: 1;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.04}px;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            font-size: 24px;
            text-align: left;
        }
    `,
    Title: styled.p`
        display: block;
        position: relative;
        margin: 0;
        color: ${CONST.COLOR.THEME};
        font-size: 6vw;
        font-weight: bold;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.06}px;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            font-size: 36px;
            text-align: left;
        }
    `,
    Image: styled.img`
        width: 100%;
        margin: 2vw 0 6vw;
        border: 1px solid ${CONST.COLOR.THEME};
        z-index: 2;

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            margin: 10px 0 0;
        }
    `,
};

const BusinessEnvironment = {
    Row: styled(Row)`
        padding: 0;

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            padding: 0 16px;
        }
    `,
    Text: styled.p`
        display: block;
        position: relative;
        margin: 0;
        color: ${CONST.COLOR.TEXT};
        font-size: 3vw;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.03}px;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            font-size: 15px;
            text-align: left;
        }
    `,
    Label: styled.p`
        display: block;
        position: relative;
        margin: 0;
        color: ${CONST.COLOR.TEXT};
        font-size: 3.5vw;
        line-height: 2;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.035}px;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            font-size: 16px;
            text-align: left;
        }

        & > span {
            color ${CONST.COLOR.THEME};
            font-size: 3.5vw;
            font-weight: bold;
            margin-right: 1px;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.035}px;
            }

            @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
                font-size: 20px;
            }
        }
    `,
};

const Analysis = () => {
    return (
        <Container>
            <Title textKr="비즈니스 환경" textEng="Business Environment"></Title>
            <Body className="mt-3 mt-sm-4">
                <BusinessEnvironment.Row className="align-items-end">
                    <Col xl={7}>
                        <Section.SubTitle>교통ㆍ조망ㆍ힐링까지 다 갖춘 업무 인프라로</Section.SubTitle>
                        <Section.Title>구로를 대표하는 비즈니스 메인 입지</Section.Title>
                        <Section.Image src={imgBusinessEnvironment} alt="" />
                    </Col>
                    <Col xl={5}>
                        <Section.SubTitle>성공 - 힐링 - 전망 - 비전을 잇는</Section.SubTitle>
                        <Section.Title>하이커넥티드 랜드마크</Section.Title>
                        <BusinessEnvironment.Text className="mt-3">서울 전역으로 통하는 교통망, 차원 높은 업무 스페이스,</BusinessEnvironment.Text>
                        <BusinessEnvironment.Text>도시전망을 감상할 수 있는 공간 걸계 등</BusinessEnvironment.Text>
                        <BusinessEnvironment.Text>구로의 새로운 미래를 열 워크타워가 열린다</BusinessEnvironment.Text>
                        <BusinessEnvironment.Label className="mt-3">
                            <span>Main_</span> G밸리, YBD, CBD, GBD 등과 인접한 서울 비즈니스의 중심
                        </BusinessEnvironment.Label>
                        <BusinessEnvironment.Label>
                            <span>Infra_</span> 아이파크몰, 중심상권 등 편리하고 다양한 인프라 조성
                        </BusinessEnvironment.Label>
                        <BusinessEnvironment.Label>
                            <span>Traffic_</span> 개봉역, 경인로, 유로IC, 남부순환로 등 초고속 교통망
                        </BusinessEnvironment.Label>
                        <BusinessEnvironment.Label>
                            <span>Demand_</span> 구로, 금천, 영등포 등 비즈니스 밀집지로 풍부한 수요
                        </BusinessEnvironment.Label>
                    </Col>
                </BusinessEnvironment.Row>
            </Body>
            <Title textKr="광역교통" textEng="Wide Area Transportation"></Title>
            <Body className="mt-3 mt-sm-4">
                <Section.SubTitle>YBD, CBD, GBD, G밸리, 마곡 등</Section.SubTitle>
                <Section.Title>서울 주요 업무지구로의 신속한 접근성</Section.Title>
                <Section.Image src={imgWideAreaTransportation} alt="" />
            </Body>
            <Title textKr="교통환경" textEng="Traffic Overview"></Title>
            <Body className="mt-3 mt-sm-4">
                <Section.SubTitle>경인로 대로변 입지, 도보 약 5분 1호선 개봉역, 남부순환로 등</Section.SubTitle>
                <Section.Title>쾌속 비즈니스를 위한 쾌적한 교통 네트워크</Section.Title>
                <Section.Image src={imgTrafficOverview} alt="" />
            </Body>
            <Title textKr="개발환경" textEng="Development Overview"></Title>
            <Body className="mt-3 mt-sm-4">
                <Section.SubTitle>고척 4구역 재개발 사업, 고척 공구상가 재건축 개발호재 등</Section.SubTitle>
                <Section.Title>고척의 가치를 높이는 개발 프리미엄의 중심</Section.Title>
                <Section.Image src={imgDevelopmentOverview} alt="" />
            </Body>
        </Container>
    );
};

export default Analysis;
